import React, { createContext, useState, useContext } from 'react'
import PropTypes from 'prop-types'

import config from '@/config'
import { COMPANY_FORM_PERSON, CONNECTION_TYPE_ONLINE } from '@/modules/client/constants'
import request from '@/modules/base/util/request'

const initialData = {
  connectionType: CONNECTION_TYPE_ONLINE,
  firstname: '',
  lastname: '',
  email: '',
  tenantId: '',
  companyForm: COMPANY_FORM_PERSON,
  companyName: '',
  clientNumber: '',
  clerkIds: [],
  id: undefined,
}

const CreateClientContext = createContext({})

export const CreateClientProvider = ({ children, clientData }) => {
  const [client, setClient] = useState(() => {
    const state = { ...initialData }
    if (clientData) {
      state.companyForm = clientData.companyForm || state.companyForm
      state.companyName = clientData.companyName || state.companyName
      state.clientNumber = clientData.clientNumber || state.clientNumber
      state.clerkIds = clientData.clerks || state.clerkIds
      state.id = clientData.id || state.id
    }
    return state
  })
  const [loading, setLoading] = useState(false)

  const patch = async(data) => setClient(prev => ({ ...prev, ...data }))

  const restart = () => setClient(initialData)

  const submit = async() =>
    new Promise((resolve, reject) => {
      setClient(async data => {
        try {
          setLoading(true)
          const url = data.id ? `${config.resourceHost}tenantCollaborations/switchToOnline/${data.id}` : `${config.resourceHost}tenantCollaborations/inviteClientTenant`
          const result = await request(url, {
            method: 'POST',
            auth: true,
            isConcurrent: true,
            timeout: 30 * 1000,
            data: {
              ...data,
              clerkIds: data.clerkIds.map(clerkId => clerkId.value),
            },
          })
          resolve(result.body.data)

        } catch (error) {
          reject(error)
        } finally {
          setLoading(false)
        }
      })
    })

  return (
    <CreateClientContext.Provider
      value={{
        loading,
        client,
        patch,
        restart,
        submit,
      }}
    >
      {children}
    </CreateClientContext.Provider>
  )
}

CreateClientProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
}

export default function useCreateUser() {
  const context = useContext(CreateClientContext)

  return context
}
